// src/components/PieCategoryChart.tsx
import { useEffect, useRef, useMemo } from "react";
import { Pie } from "@antv/g2plot";

export function PieCategoryChart({ receipts }) {
  const containerRef = useRef(null);
  const chartRef = useRef(null);

  // Transforma receipts → { label, value }[]
  const data = useMemo(() => {
    const map = receipts.reduce((acc, r) => {
      const cat = r.category || "Outros";
      acc[cat] = (acc[cat] || 0) + Number(r.totalValue);
      return acc;
    }, {});

    return Object.entries(map).map(([label, value]) => ({
      label,
      value,
    }));
  }, [receipts]);

  useEffect(() => {
    if (!containerRef.current) return;

    if (!chartRef.current) {
      chartRef.current = new Pie(containerRef.current, {
        data,
        angleField: "value",
        colorField: "label",
        radius: 0.9,
        innerRadius: 0.6,

        legend: false,

        label: {
          type: "inner",
          offset: "-50%",
          content: "{value}",
          style: {
            textAlign: "center",
            fontSize: 12,
            fill: "white",
          },
        },

        tooltip: {
          formatter: (item) => {
            const brl = item.value.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            });
            return { name: item.label, value: brl };
          },
        },

        interactions: [{ type: "element-active" }],
      });

      chartRef.current.render();
    } else {
      chartRef.current.update({ data });
    }
  }, [data]);

  return <div ref={containerRef} style={{ height: 260 }} />;
}
